// Arrange a meeting typeform URL
export const MEETING_URL = "https://form.typeform.com/to/Qbty6fUj";
